import styled from 'styled-components';

const CarouselPagination = styled.div`
  cursor: pointer;
  background-color: #ddd;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  transition: all 400ms;
  &:hover {
    background-color: ${({ theme: { colors } }) => colors.primaryDark};
    border-color: white;
    border-width: 2px;
  }
`;

export default CarouselPagination;
